import { motion } from "framer-motion";

/**
 * Signature animation: a hand-drawn breathing waveform in Terracotta.
 * The <path> draws itself on mount, then very subtly breathes (scaleY).
 * Pure SVG + framer-motion. No WebGL, no videos. ~2kb.
 */
export default function BreathingWaveform({ className = "" }) {
    // A gentle, musical waveform. Not a spectrogram — more like calligraphy.
    const d =
        "M 0 80 " +
        "C 40 80, 60 30, 100 30 " +
        "S 180 130, 220 80 " +
        "S 320 20, 380 80 " +
        "S 480 140, 540 80 " +
        "S 640 30, 700 80 " +
        "S 800 130, 860 80 " +
        "S 960 40, 1020 80";

    return (
        <motion.svg
            viewBox="0 0 1020 160"
            preserveAspectRatio="none"
            className={className}
            aria-hidden="true"
            animate={{ scaleY: [1, 1.06, 1] }}
            transition={{ duration: 4.4, repeat: Infinity, ease: "easeInOut" }}
        >
            {/* soft echo */}
            <motion.path
                d={d}
                fill="none"
                stroke="#E06D53"
                strokeWidth="1"
                strokeLinecap="round"
                opacity="0.18"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 2.6, ease: "easeOut" }}
            />
            {/* main stroke */}
            <motion.path
                d={d}
                fill="none"
                stroke="#E06D53"
                strokeWidth="1.6"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 2.2, ease: "easeOut", delay: 0.15 }}
            />
        </motion.svg>
    );
}
